import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from './app/app.config';
import { AppComponent } from './app/app';
import { TeamsService } from './app/services/teams/teams.service';

/**
 * Detect whether we are hosted inside Microsoft Teams BEFORE creating the app,
 * so the provider factory can swap the MSAL interceptor for the Teams SSO/OBO
 * interceptor. Detection is a no-op (fast false) in a normal browser.
 */
async function bootstrap(): Promise<void> {
  const isInTeams = await TeamsService.detect();

  const appRef = await bootstrapApplication(
    AppComponent,
    createAppConfig(isInTeams)
  );

  if (isInTeams) {
    // Signal the Teams host that the tab finished loading.
    appRef.injector.get(TeamsService).notifyAppLoaded();
  }
}

bootstrap().catch((err: Error) => console.error(err));
